import {css} from '@emotion/react'
import DynamicDownloadButton from './DynamicDownloadButton'

const translations = {
    en: {
        title: 'Privacy by Design.',
        subtitle: 'Private AI, Without the tracking or logging.',
    },
    de: {
        title: 'Datenschutz durch Design.',
        subtitle: 'Private KI, ohne Tracking oder Logging.',
    },
    nl: {
        // "Privacy by Design" is a fixed industry term (named in the GDPR) and
        // stays in English, same as "Anonymous View".
        title: 'Privacy by Design.',
        subtitle: 'Private AI, zonder tracking of logging.',
    }
}

const Section4 = ({languageCode = 'en', experimentId, os, browser}) => {
    const text = translations[languageCode] || translations.en

    return (
        <section
            className="sp-section4"
            css={css`
                width: 100%;
                height: 250px;
                background: #000;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 80px 20px;
                box-sizing: border-box;
            `}
        >
            <div
                className="content-wrapper"
                css={css`
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    gap: 15px;
                    max-width: 400px;
                    width: 100%;
                `}
            >
                <h2
                    css={css`
                        color: #F2F3FB;
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: 'Inter';
                        font-size: 32px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 44px;
                        letter-spacing: 0.5px;
                        margin: 0;
                        
                        @media (max-width: 380px) {
                            font-size: 28px;
                        }
                    `}
                >
                    {text.title}
                </h2>

                <p
                    css={css`
                        color: #EBECF7;
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: "Inter";
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                        letter-spacing: 0.048px;
                        margin: 0;
                        max-width: 320px;
                    `}
                >
                    {text.subtitle}
                </p>

                <div
                    css={css`
                        display: flex;
                        justify-content: center;
                        margin-top: 16px;
                    `}
                >
                    <DynamicDownloadButton
                        ctaType="cta-section4"
                        experiment={experimentId}
                        os={os}
                        browser={browser}
                        languageCode={languageCode}
                    />
                </div>
            </div>
        </section>
    )
}

export default Section4
